import { Message } from '@alifd/next';
const TOKEN = 'Admin-Token-Consumer';
function getCookie(cname) {
    var name = cname + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i].trim();
        if (c.indexOf(name) == 0)
            return c.substring(name.length, c.length);
    }
    return '';
}
const request = ({ url, method, body = {}, file = false }) => {
    return new Promise((resolve, regect) => {
        let params = {
            method,
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${getCookie(TOKEN)}`,
            },
            body: JSON.stringify(body),
        };
        if (params.body === '{}')
            delete params.body;
        fetch(url, params)
            .then((response) => file ? response.blob() : response.json())
            .then((res) => {
            if (file) {
                resolve(res);
                return;
            }
            if (res.code === 200) {
                resolve(res);
            }
            else {
                Message.error(res.msg);
                regect(res);
            }
        })
            .catch((err) => {
            Message.error(err?.msg);
            regect(err);
        });
    });
};
export default request;
